import { useCallback, useState } from 'react'
import { MIN_PAGINATION_SIZE } from 'constants/queries'
import { CustomersRequest } from 'types/customers'
import { CustomerModel } from '../helpers/types'

export const useCustomersQueryParams = (customerModel: CustomerModel) => {
  const initialQueryParams: CustomersRequest = {
    size: MIN_PAGINATION_SIZE,
    page: 0,
    search: '',
    filters: { models: [customerModel] },
  }

  const [queryParams, setQueryParams] = useState<CustomersRequest>(initialQueryParams)

  const onChangePage = useCallback((page: number) => {
    setQueryParams(current => (current?.page === page ? current : { ...current, page }))
  }, [])

  const onChangeRowsPerPage = useCallback((size: number) => {
    setQueryParams(current => (current?.size === size ? current : { ...current, size, page: 0 }))
  }, [])

  const onChangeSearchAndFilter = useCallback((updatedSearchAndFilter: CustomersRequest) => {
    setQueryParams(current => {
      const nextSearch = updatedSearchAndFilter.search ?? current?.search
      const nextFilters = updatedSearchAndFilter.filters ?? current?.filters

      const isSameSearch = nextSearch === current?.search
      const isSameFilters = JSON.stringify(nextFilters) === JSON.stringify(current?.filters)

      if (isSameSearch && isSameFilters) {
        return current
      }

      return { ...current, ...updatedSearchAndFilter, page: 0 }
    })
  }, [])

  return { queryParams, onChangePage, onChangeRowsPerPage, onChangeSearchAndFilter }
}
